import {getUrlSearchParam} from '@/utils/utils';

export const isDevelopmentEnvironment = import.meta.env.VITE_IS_DEV_ENVIRONMENT === 'true';
const isTestEnvironment = getUrlSearchParam('isTest') === 'true';

export const IS_TEST_ENVIRONMENT = isTestEnvironment && isDevelopmentEnvironment;
